
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import { colors } from "../../ui/colors";
import { EmailIcon } from "../../ui/icons/emailIcon";
import { ButtonComponent } from "../../ui/molecules/button";
import { InputComponent } from "../../ui/molecules/input";
import { SelectComponent } from "../../ui/molecules/select";
import { ModalComponent } from "../../ui/organisms/modal";
import { Roles } from "./dto";
import { createUser, editUser, resetCreateUserRequest, setCreateUserRequestCompany, setCreateUserRequestEmail, setCreateUserRequestName, setCreateUserRequestRole, setCreateUserRequestSurname, setCreateUserRequestUsername, setEditUserRequestCompany, setEditUserRequestName, setEditUserRequestSurname, setEditUserRequestUsername, setOpenNewUserModal, setUserId } from "./slice";
import { BillowButton } from "../../ui/molecules/billowButton";

export function NewUserModal() {
    const userState = useAppSelector(state => state.user)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (userState.userId.trim()) {
            const user = userState.findAllUserResponse?.users.find(item => item.id.toString() === userState.userId)
            dispatch(setEditUserRequestName(user?.name))
            dispatch(setEditUserRequestSurname(user?.surname))
            dispatch(setEditUserRequestUsername(user?.username))
            dispatch(setEditUserRequestCompany(user?.company))
            dispatch(setCreateUserRequestEmail(user?.email))
        }
    }, [userState.userId])

    return (
        <ModalComponent
            width="medium"
            open={userState.openNewUserModal || userState.userId.trim().length > 0}
            handleClose={() => {
                dispatch(setOpenNewUserModal(false));
            }}
        >
            <div
                style={{
                    padding: '20px',
                    backgroundColor: colors.white,
                    boxShadow: '0px 12px 24px 0px rgba(22, 42, 100, 0.12)',
                    borderRadius: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    width: '100%'
                }}
            >
                <div className="flex items-center justify-between">
                    <span className="text-heading-xs font-semibold text-neutral-600">{userState.userId.trim() ? 'Modifica utente' : 'Aggiungi utente'}</span>
                </div>
                <div className="flex flex-col items-start" style={{ gap: '16px', width: '100%' }}>
                    {!userState.userId.trim() && <SelectComponent value={userState.createUserRequest.role} onChange={(value) => dispatch(setCreateUserRequestRole(value))} options={[
                        { label: 'Admin', value: Roles.ADMIN },
                        { label: 'Operatore', value: Roles.OPERATOR }
                    ]} placeholder={"Scegli un ruolo"} />}
                    {(userState.createUserRequest.role !== null || userState.userId.trim()) &&
                        <>
                            <div className=" flex flex-row gap-4">
                                <InputComponent
                                    label="Nome"
                                    type={"text"}
                                    value={userState.userId.trim() ? userState.editUserRequest.name : userState.createUserRequest.name}
                                    placeholder={"Nome"}
                                    onChangeText={(value) => {
                                        userState.userId.trim() ?
                                            dispatch(setEditUserRequestName(value)) :
                                            dispatch(setCreateUserRequestName(value))
                                    }}
                                    required
                                />
                                <InputComponent
                                    label="Cognome"
                                    type={"text"}
                                    value={userState.userId.trim() ? userState.editUserRequest.surname : userState.createUserRequest.surname}
                                    placeholder={"Cognome"}
                                    onChangeText={(value) => {
                                        userState.userId.trim() ?
                                            dispatch(setEditUserRequestSurname(value)) :
                                            dispatch(setCreateUserRequestSurname(value))
                                    }
                                    }
                                    required
                                />
                            </div>
                            <InputComponent
                                label="Username"
                                type={"text"}
                                value={userState.userId.trim() ? userState.editUserRequest.username : userState.createUserRequest.username}
                                placeholder={"Username"}
                                onChangeText={(value) => {
                                    userState.userId.trim() ?
                                        dispatch(setEditUserRequestUsername(value)) :
                                        dispatch(setCreateUserRequestUsername(value))
                                }}
                                required
                            />
                            <InputComponent
                                label="Email"
                                type={"text"}
                                disabled={userState.userId.trim().length > 0}
                                placeholder="Email"
                                startIcon={<EmailIcon size={"20"} color={colors.neutral[400]} />}
                                value={userState.createUserRequest.email}
                                onChangeText={(value) => dispatch(setCreateUserRequestEmail(value.toLowerCase()))}
                                required
                            />
                            <InputComponent
                                label="Azienda"
                                type={"text"}
                                placeholder="Azienda"
                                value={userState.userId.trim() ? userState.editUserRequest.company : userState.createUserRequest.company}
                                onChangeText={(value) => userState.userId.trim() ? dispatch(setEditUserRequestCompany(value)) :
                                    dispatch(setCreateUserRequestCompany(value))
                                }
                                required
                            />
                        </>
                    }
                </div>
                <div className={"flex gap-3 items-center w-full justify-center"}>
                    <BillowButton
                        label={"Annulla"}
                        onClick={() => {
                            dispatch(setOpenNewUserModal(false))
                            dispatch(setUserId(''))
                            dispatch(resetCreateUserRequest())
                        }}
                        variant={"outline"}
                        iconPosition="off"
                        fullWidth
                    />
                    <BillowButton
                        label={userState.userId.trim() ? "Modifica" : "Aggiungi"}
                        onClick={() => {
                            dispatch(setUserId(""))
                            dispatch(setOpenNewUserModal(false))
                            if (userState.userId.trim())
                                dispatch(editUser({ request: userState.editUserRequest, id: userState.userId }))
                            else
                                dispatch(createUser(userState.createUserRequest))

                        }}
                        variant={"solid"}
                        iconPosition="off"
                        fullWidth
                        disabled={
                            (!userState.userId.trim() && (userState.createUserRequest.name === "" ||
                                userState.createUserRequest.surname === "" ||
                                userState.createUserRequest.email === "" ||
                                !/^[A-z0-9\.\+_-]+@[A-z0-9\._-]+\.[A-z]{2,6}$/.test(userState.createUserRequest.email) ||
                                !userState.createUserRequest.company.trim())
                            )
                        }
                    />
                </div>
            </div>
        </ModalComponent >
    )
}